export default __webpack_public_path__ + "static/BigLogoWhite-bdb4b0066f46d9a89cd2507374b9cdd8.svg";